import { render } from "./TableWithFixedColumn.vue?vue&type=template&id=3cb802ec"
import script from "./TableWithFixedColumn.vue?vue&type=script&lang=js"
export * from "./TableWithFixedColumn.vue?vue&type=script&lang=js"
script.render = render

export default script